var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEspacoGourmet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "espaco_gourmet",
    "data-name": "espaco gourmet",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.186,
    height: 80.818,
    viewBox: "0 0 107.186 96.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1267",
    "data-name": "Caminho 1267",
    d: "M19.409,30.166a1.786,1.786,0,0,0,2.526-2.526,4.661,4.661,0,0,1,0-6.581,8.22,8.22,0,0,0,0-11.633,1.786,1.786,0,0,0-2.526,2.526,4.649,4.649,0,0,1,0,6.581A8.236,8.236,0,0,0,19.409,30.166Z",
    transform: "translate(13.372 1.817)",
    fill: "#cb8f55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1268",
    "data-name": "Caminho 1268",
    d: "M41.409,30.166a1.786,1.786,0,0,0,2.526-2.526,4.661,4.661,0,0,1,0-6.581,8.22,8.22,0,0,0,0-11.633,1.786,1.786,0,1,0-2.526,2.526,4.649,4.649,0,0,1,0,6.581A8.236,8.236,0,0,0,41.409,30.166Z",
    transform: "translate(30.674 1.817)",
    fill: "#cb8f55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1269",
    "data-name": "Caminho 1269",
    d: "M30.409,24.166a1.786,1.786,0,0,0,2.526-2.526,4.661,4.661,0,0,1,0-6.581,8.22,8.22,0,0,0,0-11.633,1.786,1.786,0,0,0-2.526,2.526,4.649,4.649,0,0,1,0,6.581A8.236,8.236,0,0,0,30.409,24.166Z",
    transform: "translate(22.023 -2.902)",
    fill: "#cb8f55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1270",
    "data-name": "Caminho 1270",
    d: "M26.131,30.586a1.868,1.868,0,0,0,.395-.043,35.981,35.981,0,0,1,7.9-.872h.023a1.786,1.786,0,1,0,0-3.573h-.025a39.607,39.607,0,0,0-8.682.959,1.786,1.786,0,0,0,.391,3.528Z",
    transform: "translate(19.146 15.341)",
    fill: "#cb8f55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1271",
    "data-name": "Caminho 1271",
    d: "M10.466,57.84a1.659,1.659,0,0,0,.322.03,1.787,1.787,0,0,0,1.756-1.465,35.751,35.751,0,0,1,16.41-24.224,1.786,1.786,0,1,0-1.82-3.074A39.369,39.369,0,0,0,9.03,55.762,1.783,1.783,0,0,0,10.466,57.84Z",
    transform: "translate(7.078 17.511)",
    fill: "#cb8f55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1272",
    "data-name": "Caminho 1272",
    d: "M99.369,64.659a46.559,46.559,0,0,0-36.92-37.772,8.218,8.218,0,0,0,.077-.857,8.932,8.932,0,1,0-17.864,0,7.758,7.758,0,0,0,.077.857A46.559,46.559,0,0,0,7.817,64.659C4.084,66.772,0,69.883,0,73.372c0,9.084,27.711,15.185,53.593,15.185s53.593-6.1,53.593-15.185C107.186,69.883,103.1,66.772,99.369,64.659ZM48.245,26.338c-.007-.1-.011-.207-.011-.307a5.359,5.359,0,1,1,10.719,0c0,.1,0,.2-.011.307-.084-.009-.168-.013-.25-.021-.615-.068-1.233-.116-1.854-.159-.229-.016-.456-.039-.684-.052-.847-.046-1.7-.073-2.558-.073s-1.711.027-2.558.073c-.229.013-.456.036-.684.052-.622.043-1.24.093-1.854.159C48.412,26.326,48.328,26.328,48.245,26.338ZM47.16,30.086c.959-.143,1.924-.247,2.892-.325.2-.016.4-.03.595-.045a43.84,43.84,0,0,1,5.893,0c.2.014.4.029.595.045.968.079,1.933.182,2.892.325a42.972,42.972,0,0,1,36,36.293c.082.573.148,1.149.207,1.724.02.2.046.395.064.593.07.791.121,1.583.146,2.374a190.643,190.643,0,0,1-85.7,0q.04-1.187.146-2.374c.018-.2.043-.395.064-.593.059-.577.125-1.152.207-1.724A42.966,42.966,0,0,1,47.16,30.086Zm6.433,54.9c-30.541,0-50.02-7.626-50.02-11.612,0-.684.847-2.192,3.687-4.159-.007.1,0,.2-.011.3-.061.979-.1,1.965-.1,2.962v1.408l1.37.33a193.459,193.459,0,0,0,45.077,5.309A193.363,193.363,0,0,0,98.67,74.217l1.37-.33V72.478c0-1-.043-1.981-.1-2.962-.007-.1,0-.2-.011-.3,2.84,1.967,3.687,3.475,3.687,4.159C103.613,77.357,84.134,84.983,53.593,84.983Z",
    transform: "translate(0 8.262)",
    fill: "#cb8f55"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspacoGourmet);
export default __webpack_public_path__ + "static/media/espaco-gourmet.bb326041a6cbb9aa2d51a7f579b2a3a9.svg";
export { ForwardRef as ReactComponent };